var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"rounded":"","small":"","color":"secondary","block":_vm.isMobile()},on:{"click":function($event){return _vm.$router.push({
      name: 'editar-dependente',
      params: { id: _vm.dependente.codigo },
    })}}},[_c('v-icon',{staticClass:"mr-1",attrs:{"size":"17"}},[_vm._v("mdi-pencil")]),_vm._v(" Editar Dependente")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }